export default "__VITE_ASSET__Ds2x1FDk__"